export default "__VITE_ASSET__D26M1WvY__"